// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_profile__main-content-wrapper__9PQmb {
  margin-block: 10rem;
  display: flex;
  gap: 5rem;
  align-items: flex-start;
}

.Profile_profile__main-content__rUDur {
  flex-grow: 1;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .Profile_profile__main-content-wrapper__9PQmb {
    gap: 3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/Profile.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,SAAS;EACX;AACF","sourcesContent":[".profile__main-content-wrapper {\n  margin-block: 10rem;\n  display: flex;\n  gap: 5rem;\n  align-items: flex-start;\n}\n\n.profile__main-content {\n  flex-grow: 1;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .profile__main-content-wrapper {\n    gap: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile__main-content-wrapper": `Profile_profile__main-content-wrapper__9PQmb`,
	"profile__main-content": `Profile_profile__main-content__rUDur`
};
export default ___CSS_LOADER_EXPORT___;
